module.exports = __webpack_public_path__ + "static/media/01_1.ea458c9b.gif";